import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ISipPhoneContact } from '@obvious.tech/constellation'

export const SipPhoneContact = defineEntity('SipPhoneContact', {
  endpoint: 'sip/api/SipPhoneContact',
  schema: SNoop<ISipPhoneContact>(),
})
